import { render, staticRenderFns } from "./search-adverts.vue?vue&type=template&id=646e35ba"
import script from "./search-adverts.vue?vue&type=script&lang=ts"
export * from "./search-adverts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports